// extracted by mini-css-extract-plugin
module.exports = {"label":"AttributeLabel_label__4wVrZ","text":"AttributeLabel_text__26kIz","checkbox":"AttributeLabel_checkbox__blDJ8"};